import { Directive } from '@angular/core';

@Directive({
  selector: '[dhlCurrencyField]'
})
export class CurrencyFieldDirective {

}
